import {
  SheetEntity,
} from './sheetEntity';
import { AbsenceReason } from './valueObjects/absenceReason';
import { AbsenceReasonDetailInfection } from './valueObjects/absenceReasonDetailInfection';
import { AbsenceReasonDetailSick } from './valueObjects/absenceReasonDetailSick';
import { AttendDateTime } from './valueObjects/attendDateTime';
import { AttendStatus } from './valueObjects/attendStatus';
import { AttendanceDate } from './valueObjects/attendanceDate';
import { ChildId } from './valueObjects/childId';
import { LeaveDateTime } from './valueObjects/leaveDateTime';
import { MemberId } from './valueObjects/memberId';
import { Memo } from './valueObjects/memo';
import { ParentId } from './valueObjects/parentId';

import type {
  SheetPropsPub,
  SheetPropsPvt,
} from './sheetEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { SheetJsonPub, SheetJsonPvt } from '@/types/domain/attendance/entities/sheetEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class SheetFactory extends FactoryPub<
  SheetEntity,
  SheetPropsPvt,
  SheetJsonPvt,
  SheetPropsPub,
  SheetJsonPub
> {
  comparePub = (
    a: EntityDataPubType<SheetJsonPvt, SheetJsonPub>,
    b: EntityDataPubType<SheetJsonPvt, SheetJsonPub>,
  ) => {
    const da = new Date(a.data.attendanceDate);
    const db = new Date(b.data.attendanceDate);
    return da < db ? 1 : -1;
  };

  create(
    props: SheetPropsPvt,
    propsPub: EntityPubNotNullType<SheetPropsPub>,
  ): SheetEntity {
    return new SheetEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<SheetJsonPvt, SheetJsonPub>,
  ): SheetEntity {
    return this.create({
      attendanceDate: AttendanceDate.create(new Date(props.data.attendanceDate)),
      parentId: ParentId.create(props.data.parentId),
      childId: ChildId.create(props.data.childId),
      attendStatus: AttendStatus.create(props.data.attendStatus),
      absence: props.data.absence ? {
        reason: AbsenceReason.create(props.data.absence.reason),
        reasonDetailInfection:
          props.data.absence.reasonDetailInfection
            ? AbsenceReasonDetailInfection.create(props.data.absence.reasonDetailInfection)
            : undefined,
        reasonDetailSick:
          props.data.absence.reasonDetailSick
            ? AbsenceReasonDetailSick.create(props.data.absence.reasonDetailSick)
            : undefined,
        memo: Memo.create(props.data.absence.memo),
        memberId: MemberId.create(props.data.absence.memberId),
      } : undefined,
      attend: props.data.attend ? {
        memberId: MemberId.create(props.data.attend.memberId),
        attendDateTime: AttendDateTime.create(new Date(props.data.attend.attendDateTime)),
      } : undefined,
      leave: props.data.leave ? {
        memberId: MemberId.create(props.data.leave.memberId),
        leaveDateTime: LeaveDateTime.create(new Date(props.data.leave.leaveDateTime)),
      } : undefined,
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
